import type { IAuditTrailStates, IAuditTrailUserStates } from '../../../interface/state/IAuditTrailState';
import { auditTrailType } from '../../types';
import { getCommandQuery, type IGetQuery } from '../api-utils';
import * as utils from '../utils';

export const get_AuditTrailUser = ({ query, onFailure, onSuccess, paged }: IGetQuery<IAuditTrailUserStates>) =>
	utils.httpGetMethod({
		apiData: {
			url: `/api/AuditTrail/user${getCommandQuery(paged, ...(query || []))}&Type=create&Type=update&Type=delete`,
			header: utils.header(),
		},
		actionType: auditTrailType.get_AuditTrailUser,
		onFailure,
		onSuccess,
	});

export const get_AuditTrailAll = ({ query, onFailure, onSuccess, paged }: IGetQuery<IAuditTrailStates>) =>
	utils.httpGetMethod({
		apiData: {
			url: `/api/AuditTrail/GetAll${getCommandQuery(paged, ...(query || []))}&Type=create&Type=update&Type=delete`,
			header: utils.header(),
		},
		actionType: auditTrailType.get_AuditTrailAll,
		onFailure,
		onSuccess,
	});
